import { useMemo } from 'react';
import dayjs from 'dayjs';

import { IS_BIG_SALE } from '~/domains/plusMembership/constants';
import { usePlusMembershipEvent } from '~/domains/plusMembership/queries';

import { BigSalePromotionCountdown } from './BigSalePromotionCountdown';
import { PmwkPromotionCountdown } from './PmwkPromotionCountdown';

export function MembershipPromotionCountDown() {
  const { data } = usePlusMembershipEvent();

  const initialTime = useMemo(() => {
    if (!data?.event?.endAt) return undefined;
    return dayjs(data?.event?.endAt).valueOf() - dayjs().valueOf();
  }, [data?.event?.endAt]);

  if (!initialTime) return null;

  return IS_BIG_SALE ? (
    <BigSalePromotionCountdown initialTime={initialTime} />
  ) : (
    <PmwkPromotionCountdown initialTime={initialTime} />
  );
}
